import { Col, Navbar, NavbarBrand, Row } from "reactstrap";
import styles from "./style.module.scss";
import LoginForm from "@components/forms/LoginForm";
import HeaderLink from "@components/content/HeaderLink";

import Logo from '@assets/Logo.png';
import LockIcon from '@assets/icons-png/lock.png';
import ProfileIcon from '@assets/icons-png/profile.png';
import HomeIcon from '@assets/icons-png/home.png';
import LinksIcon from '@assets/icons-png/links.png';

import { useAppDispatch, useAppSelector } from "store/hooks";
import { useEffect } from "react";
import { isLogin } from "@utils/Session";
import { login, logout } from "store/slices/userSlides";
import { checkSuscritionActive, fetchSuscription, SuscriptionDataType } from "@/api/SuscriptionsApi";
import { clearSuscriptionData, setPlanFeatures, setSuscriptionData, setTenantData } from "@/store/slices/suscriptionSlides";
import { useNavigate } from "react-router-dom";
import { TenantApi } from "@/api/TenantApi";
import { TenantPausedError } from "@/api/ApiClient";
import { SuscriptionTypeApi } from "@/api/SuscriptionTypeApi";
import { parsePlanFeatures } from "@/security/features.catalog";


const UserNavMenu = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch();
  const isUserLoggedIn = useAppSelector((state) => state.user.isLogin);
  const suscriptionData = useAppSelector((state) => state.suscription.suscription);

  useEffect(() => {
    isLogin().then(isLoggedIn => {
      if (isLoggedIn) {
        dispatch(login());
        if (!suscriptionData?.id) {
          loadSuscriptionData()
        }
      } else {
        logoutUser()
      }
    });
  }, []);

  const logoutUser = () => {
    dispatch(logout());
    dispatch(clearSuscriptionData())
    navigate("/auth/logout")
  }

  const loadSuscriptionData = async () => {
    const profileData = await fetchSuscription();
    try {
      const suscriptionActive = await checkSuscritionActive(`${profileData?.id || ""}`)
      if (!suscriptionActive) {
        logoutUser()
      } else {
        await syncProfileDataWithStore(profileData)
      }
    } catch (error) {
      if (error instanceof TenantPausedError) {
        await syncProfileDataWithStore(profileData)
        navigate("/user/tenant-manage")
      }
    }
  }

  const syncProfileDataWithStore = async (profileData: SuscriptionDataType) => {
    dispatch(setSuscriptionData(profileData))
    try {
      const tenantData = await TenantApi.fetchTenantBySuscriptionId(`${profileData.id}`)
      dispatch(setTenantData(tenantData))
      await loadPlanFeatures(tenantData.suscriptionTypeId)
    } catch (err) {
      console.error("Unable to load TenantData", err)
      dispatch(setPlanFeatures(null))
    }
  }

  const loadPlanFeatures = async (suscriptionTypeId?: string | null) => {
    // Fail-open: ante cualquier fallo de carga no se bloquea al tenant
    try {
      if (!suscriptionTypeId) {
        dispatch(setPlanFeatures(null))
        return
      }
      const suscriptionType = await SuscriptionTypeApi.get(suscriptionTypeId)
      dispatch(setPlanFeatures(parsePlanFeatures(suscriptionType?.features)))
    } catch (err) {
      console.error("Unable to load SuscriptionType features", err)
      dispatch(setPlanFeatures(null))
    }
  }

  return (
    <>
      <Navbar
        className={styles.mainNav}
        expand="md"
        light
      >
        <Col
          lg="1"
          sm={{
            size: 2,
            offset: 0
          }}
          xs={{
            size: 4,
            offset: 4
          }}>
          <NavbarBrand href="/user/dashboard">
            <img className="img-responsive" src={Logo} alt="Logo" />
          </NavbarBrand>
        </Col>
        <Col xs="12" md="6" lg="5" xl="4">
          {!isUserLoggedIn && (<LoginForm />)}
          {isUserLoggedIn && (
            <Row className="g-0">
              <Col sm="3" xs="3">
                <HeaderLink to="/user/links" icon={LinksIcon} iconAlt="Enlaces" linkText="Enlaces" />
              </Col>
              <Col sm="3" xs="3">
                <HeaderLink to="/user/profile" icon={ProfileIcon} iconAlt="Perfil" linkText="Perfil" />
              </Col>
              <Col sm="3" xs="3">
                <HeaderLink to="/" icon={HomeIcon} iconAlt="Inicio" linkText="Inicio" />
              </Col>
              <Col sm="3" xs="3">
                <HeaderLink to="/auth/logout" icon={LockIcon} iconAlt="Cerrar Sesion" linkText="Cerrar Sesion" />
              </Col>
            </Row>
          )}
        </Col>
      </Navbar >
    </>
  );
}
export default UserNavMenu;